import { useState, React } from "react";
import "bootstrap-italia/dist/css/bootstrap-italia.min.css";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import "./App.css";
import Body from "./Body/Body";
import { BrowserRouter } from "react-router-dom";
import { createContext } from "react";
import Cookies from "universal-cookie";

export const Context = createContext();

function App() {
  const cookies = new Cookies();
  const [apiToken] = useState(cookies.get("token_key"));
  const [subfolder, setSubFolder] = useState(process.env.PUBLIC_URL);
  const [dataStruttura, setDataStruttura] = useState(false);

  return (
    <div className="App">
      <Context.Provider
        value={{
          subfolder,
          apiToken,
        }}
      >
        <BrowserRouter {...(subfolder && { basename: subfolder })}>
          <Header
            subfolder={subfolder ? subfolder : ""}
            dataStruttura={dataStruttura}
          />
          <Body
            subfolder={subfolder ? subfolder : ""}
            setDataStruttura={setDataStruttura}
          ></Body>
          <br />
          <Footer />
        </BrowserRouter>
      </Context.Provider>
    </div>
  );
}

export default App;
